
import Vue from "vue";
import vueSweetalert2 from "vue-sweetalert2";
Vue.use(vueSweetalert2)

const SwalUtils = {


	setDefaultOptions( _title, _html, _icon) {
		var options = {}
		if ( _title != null ) options.title = _title
		if ( _html != null ) options.html = _html
		if ( _icon != null ) options.icon = _icon
		return options;
	},


	fire( _title, _html, _icon, _showCancelButton = null, _showDenyButton = null ) {

		var options = this.setDefaultOptions(_title, _html, _icon);

		options.confirmButtonText = 'OK'
		if ( _showCancelButton != null ) {
			options.showCancelButton = _showCancelButton
			options.confirmButtonText = 'YES'
			options.cancelButtonText = 'NO'
		}
		if ( _showDenyButton != null ) {
			options.showCancelButton = false
			options.showDenyButton = _showDenyButton
			options.confirmButtonText = 'OK'
			options.denyButtonText = 'Cancel'
		}

		return Vue.swal(options)
	},

	/**
	 * BOX → 상상플렉스 SSO 라이선스 인증 실패 시 안내 팝업
	 * @param {string} [serverMsg] API result.msg 등 서버에서 내려준 사유(맨 위에 표시)
	 */
	fireSsoLicenseAuthGuide(serverMsg) {
		const noticeUrl =
			"https://www.ssflex.co.kr/app/board/site_notice?mode=list&page=0&size=15&sort=createDate,DESC&searchKey=&searchText=&statusCode=&cateCode=&idx=17535&boardKey=site_notice";
		const licenseManagementUrl = "https://www.ssflex.co.kr/box-series/licenseManagement";
		const raw = serverMsg != null ? String(serverMsg).trim() : "";
		const safeMsg = raw
			? raw
					.replace(/&/g, "&amp;")
					.replace(/</g, "&lt;")
					.replace(/>/g, "&gt;")
					.replace(/"/g, "&quot;")
					.replace(/\n/g, "<br>")
			: "";
		const msgBlock = safeMsg
			? `<p style="margin:0 0 1em 0;padding-bottom:1em;border-bottom:1px solid #e0e0e0;font-weight:500;">${safeMsg}</p>`
			: "";
		const html = `
<div class="sso-license-guide" style="text-align:left;font-size:14px;line-height:1.65;color:#333;">
${msgBlock}
<p style="margin:0 0 1em 0;">* 2027 BOX 시리즈 신버전부터는 상상플렉스   라이선스 인증이 필수입니다. 아래 공지사항을 확인해 주시기 바랍니다.</p>
<p style="margin:0 0 1em 0;"><a href="${noticeUrl}" target="_blank" rel="noopener noreferrer" style="font-weight:bold;text-decoration:underline;">[공지] 2027 BOX 시리즈 신버전 라이선스 인증 방식 변경 안내</a></p>
</div>`;
		return this.fire("로그인 인증 안내", html, "info");
	},

	gritter(_title, _html, _icon, _timer, _callback) {

		var options = this.setDefaultOptions(_title, _html, _icon);
		( _timer == null ) ? options.timer = 3000 : options.timer = _timer
		options.showConfirmButton = false;
		options.position = 'top-end'
		return Vue.swal(options).then((e) => { _callback instanceof Function ? _callback(e) : (() => {})() });
	}

}

export default SwalUtils;
